import React, { useContext, useState, useEffect, useRef } from 'react';
import { store } from 'components/Store';
import StakeHolderList from './StakeHolderList';
import StakeHolderNoMogulUsers from './StakeHolderNoMogulUsers';
import { useAuth0 } from '@auth0/auth0-react';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import InfluenceNotIncludedFeaturesPopup from 'components/Dashboard/Influence/CrmContacts/InfluenceNotIncludedFeaturesPopup';
import { useLocation, useParams } from 'react-router-dom';
import { useNoTopicsCondition } from 'components/Dashboard/components/EmptyMessage';
import NoTopicsView from 'components/Settings/Topics/NoTopicsView';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';

const StakeHolders = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { query, activePlan } = state;
  const { enableStakeholders } = activePlan;
  const location = useLocation();
  const params = useParams();
  const { isAuthenticated } = useAuth0();
  const { referenceSection, searchResultsSection, mainSectionTitle } = useMainSectionParameter(params);
  const { addMetaTags } = useAddMetaTags();

  const initialFunction = useRef(null);
  initialFunction.current = () => {
    if (!isAuthenticated || !enableStakeholders) {
      setPageTitle();
    }
  };

  const setPageTitle = () => {
    let title = `${mainSectionTitle}${mainSectionTitle !== '' ? 'Stakeholders' : 'Stakeholder mapping'} - PolicyMogul`;
    let hash = '';
    addMetaTags({ title, hash });
  };

  useEffect(() => {
    initialFunction.current();
  }, [query]);

  const stakeholdersConditional =
    (isAuthenticated && enableStakeholders) ||
    referenceSection ||
    searchResultsSection ||
    location.pathname === '/general-election-2024/candidates';

  const stakeholderMapping =
    location.pathname.includes('/stakeholder-mapping') || location.pathname.includes('/policymakers');

  const policymakersSection = location.pathname.includes('/policymakers');
  const [showStakeholdersCrmPopup, setShowStakeholdersCrmPopup] = useState(false);
  const { newAgencyNoTopicsCondition } = useNoTopicsCondition();

  return (
    <>
      <div
        className={`${stakeholderMapping ? 'main-content pr-xl-5 px-md-4 px-3 h-100' : ''} ${
          policymakersSection ? 'flex-grow-1 pl-xl-5' : ''
        }`}
      >
        <>
          {!stakeholdersConditional && <StakeHolderNoMogulUsers />}
          {stakeholdersConditional && (
            <>
              {newAgencyNoTopicsCondition ? (
                <div className='empty-main-container'>
                  <div className='bg-white box-top-rounded '>
                    <NoTopicsView />
                  </div>
                </div>
              ) : (
                <StakeHolderList setShowStakeholdersCrmPopup={setShowStakeholdersCrmPopup} />
              )}
            </>
          )}
        </>
      </div>
      <InfluenceNotIncludedFeaturesPopup
        showPopup={showStakeholdersCrmPopup}
        type={'contacts'}
        setShowPopup={setShowStakeholdersCrmPopup}
      />
    </>
  );
};

export default StakeHolders;
